import React from 'react';
import { InputLabel, FormControl, Select } from 'material-ui';
import _ from 'lodash';

export default (props) => {

	let value = undefined;

	let options = props.options;
	if( _.isObject(options[0]) ){
		value = _.findIndex(options, option => option.value === props.value);
	}else{
		value = _.findIndex(options, option => option === props.value);
	}

	let lastClick = '';

	return (
	<FormControl margin={props.margin === undefined ? "normal" : props.margin } style={{width: props.width, display:props.newRow ? 'flex' : undefined}} >
		{ !!props.label && <InputLabel htmlFor={props.id}>{props.label}</InputLabel> }
		<Select
			native
			value={ value}
			onClick={e=>{ if(lastClick==='click'){ lastClick = ''; if(props.onSameValueChange){props.onSameValueChange(props.options[e.currentTarget.value]);} }else{ lastClick = 'click';} }}
			onBlur={e=>{ lastClick =''; }}
			onFocus={e=>{ lastClick =''; }}
			onChange={ (e)=>{ lastClick=''; let v = e.currentTarget.value; setTimeout(()=>{ lastClick=''; props.onChange(props.options[v]);}) }}
			inputProps={{id:props.id}}
			>
			{ props.options.map( (option, i) =>
				<option key={i} value={i}>{  _.isObject(option) ? option.label : option }</option>
			)}
		</Select>
	</FormControl>
)};


// WEBPACK FOOTER //
// ./src/components/Select.js